const LoadingButton = ({ isLoading, onClick, children, ...attributes }) => {
    return (
        <button onClick={isLoading ? null : onClick } {...attributes}>
            <div className={isLoading ? 'd-none' : ''}>{children}</div>
            <div className={isLoading ? '' : 'd-none'}>
                <span className="spinner-border spinner-border-xs"></span>
            </div>
        </button>
    );
};

export default LoadingButton;
